module.exports = __webpack_public_path__ + "fonts/73e878b.ttf";